module.exports = __webpack_public_path__ + "img/Signatureold.21e57a85.svg";